module.exports = __webpack_public_path__ + "media/images/emblems/Heimberg-coat_of_arms-bc52bb383fee0f5c15cba609570161aa.svg";